import { CartModesEP } from '@/screen/CartEducationalPlan/CartEducationalPlanScreen';
import { ADD_FUND, UPDATE_FUND, REMOVE_FUND, CLEAR_CART, MODEL_PERCENTAGE_TOTAL, UPDATE_FUND_MODEL_PERCENTAGE, CART_STATE, MODEL_PORTFOLIO_NAME, PUNCTUAL_CONTRIBUTION_PORTFOLIO_ID, ADD_COMPETITION, MODEL_PORTFOLIO_ID, ADD_COMPETITION_INFO, SET_CART_SENDING } from './Constants';
import type { AppThunk } from "@/store/thunk";

interface IActionLineEP
{
	fund: any
	amount: number,
	modelPercentage?: number
	readOnly?: boolean,
	userSuscriptionId?: number,
	savingsPlanId?: number,
	source?: string
}
interface IActionFundEP
{
	isin: string
}

export interface ICompetitionInfo
{
	origin: string;
	isPromotionated: boolean;
	competitionId: number;
	name: string;
}

export const addCompetitionDataInLs = (value: ICompetitionInfo): AppThunk => async (dispatch) =>
{
    await dispatch(
    {
        type: ADD_COMPETITION_INFO,
        payload: value
    });
};

export const addCompetitionInLS = (value: number): AppThunk => async (dispatch) =>
{
	await dispatch(
    {
        type: ADD_COMPETITION,
        payload: value
    });
};

export const addLineEP = (value: IActionLineEP): AppThunk => async (dispatch) =>
{
	await dispatch(
    {
        type: ADD_FUND,
        payload: value
    });
};
export const updateLineEP = (value: IActionLineEP): AppThunk => async (dispatch) =>
{
	await dispatch(
    {
        type: UPDATE_FUND,
        payload: value
    });
};
export const removeLineEP = (value: IActionFundEP): AppThunk => async (dispatch) =>
{
	await dispatch(
    {
        type: REMOVE_FUND,
        payload: value
    });
};
export const clearCartEP = (): AppThunk => async (dispatch) =>
{
	await dispatch(
    {
        type: CLEAR_CART,
    });
};
export const updateModelPercentageLineEP = (value: IActionLineEP): AppThunk => async (dispatch) =>
{
	await dispatch(
    {
        type: UPDATE_FUND_MODEL_PERCENTAGE,
        payload: value
    });
};
export const updateModelPercentageTotalEP = (value: Number): AppThunk => async (dispatch) =>
{
	await dispatch(
    {
        type: MODEL_PERCENTAGE_TOTAL,
        payload: value
    });
};

export const cartStateEP = (value: CartModesEP): AppThunk => async (dispatch) =>
{
	await dispatch(
    {
        type: CART_STATE,
        payload: value
    });
};

export const updateModelPortfolioNameEP = (value: string): AppThunk => async (dispatch) =>
{
	await dispatch(
    {
        type: MODEL_PORTFOLIO_NAME,
        payload: value
    });
};

export const updateModelPortfolioIdEP = (value: string): AppThunk => async (dispatch) =>
{
	await dispatch(
		{
			type: MODEL_PORTFOLIO_ID,
			payload: value
		});
};

export const setPunctualContributionPortfolioDataEP = (value: any): AppThunk => async (dispatch) =>
{
	await dispatch(
    {
        type: PUNCTUAL_CONTRIBUTION_PORTFOLIO_ID,
        payload: { name: value.name, id: value.id }
    });
};

export const setCartSendingEP = (value: boolean): AppThunk => async (dispatch) =>
{
	await dispatch(
    {
        type: SET_CART_SENDING,
        payload: value
    });
};